import React, { useEffect, useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { applyDesignTheme, drawType } from '../utilsDesign';

export const Background = React.memo(({
  user,
  design,
  activePage,
  aura = true,
  theme = false,
  style,
  className,
  children
}) => {
  // const context = { ...useContext(Context), ...useContext(StateContext) };

  let { userId } = useParams();

  user = user ? user : userId;

  const [designInner, setDesignInner] = useState(design)

  useEffect(() => {
    setDesignInner(design)
  }, [design])

  useLayoutEffect(() => {
    if (!theme) return;
    applyDesignTheme(design);
  }, [design?.type, design?.id, theme])

  const typeClass = designInner && drawType(designInner.type, 'class');

  return (
    <>


      <div className={['x_edu_bg', className, typeClass].filter(Boolean).join(' ')}
        style={{ ...style }}
      >
        {/* {Boolean(children) && <div style={{ zIndex: 1 }}>{children}</div>} */}
        {aura && <div className={['x_edu_aurabg', typeClass, className, activePage && `page--${activePage}`].filter(Boolean).join(' ')} />}
      </div>

    </>
  )
})